import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft,faUser,faUsers,faBriefcase,faComment,faGlobe,faCalendar,faImage,faCog,faCode,faStar,faSave,faTimes,faMailBulk
} from '@fortawesome/free-solid-svg-icons';


const CreateClient = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email:'',
    jobTitle:'',
    photoUrl:null,
    projectIds:[],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const handleFileChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      const uploadFile = /\.jfif$/i.test(selectedFile.name)
        ? new File([selectedFile], selectedFile.name.replace(/\.jfif$/i, '.jpg'), {
            type: selectedFile.type || 'image/jpeg',
          })
        : selectedFile;
      setFormData(prev => ({ ...prev, photoUrl: uploadFile }));
    }
  };
const onCancel = () => {
    navigate('/admin/clients');
  };
  const handleSubmit = async (e) => {
  const token = localStorage.getItem('token');
    e.preventDefault();
    const data =new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('jobTitle', formData.jobTitle);
      if (formData.photoUrl instanceof File) {
    data.append('photoUrl', formData.photoUrl);
  }
    try {

      const res = await axios.post('/client', data, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Client créé avec succès !');
      navigate('/admin/clients');
    } catch (err) {
      console.error("Erreur lors de la création :", err.response?.data || err.message);
      const message = err.response?.data?.message || 'Erreur lors de la création du client.';
      alert(Array.isArray(message) ? message.join(', ') : message);
    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <button className="back-button" onClick={onCancel}>
          <FontAwesomeIcon icon={faArrowLeft} />
          Retour
        </button>
        <h3>Créer un nouveau client</h3>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="client-form">
          <div className="form-section">
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} className="label-icon" />
                Nom du client
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Entrez le nom du client"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMailBulk} className="label-icon" />
                E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Entrez l'e-mail du client"
                className="form-textarea"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" />
                Poste / fonction (facultatif)
              </label>
              <input
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                placeholder="ingénieur"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faImage} className="label-icon" />
                L’image
              </label>
              <input
                type="file"
                name="photoUrl"
                accept="image/png,image/jpeg,image/jpg,image/jfif,image/svg+xml,.jfif"
                onChange={handleFileChange}
                placeholder="image.jpg"
                className="form-input"
              />
            </div>
             </div>

          <div className="form-actions">
            <button type="submit" className="btn-save">
            <FontAwesomeIcon icon={faSave} />
            Enregistrer
            </button>
            <button type="button" className="cancel-button" onClick={onCancel}>
            <FontAwesomeIcon icon={faArrowLeft} />
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateClient;
